import React from 'react';
import classnames from 'classnames';
import { noop, isEmpty, join } from 'lodash';

// local dependencies
import { searchInput as SearchInput } from 'ui/views/generic/searchInput';
import { GLOBAL_LABELS, DATA_TYPES } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { typeahead as TypeaheadView } from './typeahead.view';
 *
 * // render
 * <TypeaheadView propName='propValue'/>
 */

// select box without Search
const SelectBox = React.forwardRef( ( props, forwardedRef ) => {
    const selectBoxClassname = classnames( 'ui-typeahead__select-box', {
        'ui-typeahead__select-box--disabled': props.disabled,
        'ui-typeahead__select-box--multi-select': props.type === DATA_TYPES.MULTI_SELECT
    } );

    const titleClassName = classnames( 'ui-typeahead__select-box__title', {
        'ui-typeahead__select-box__title--multi-select': props.type === DATA_TYPES.MULTI_SELECT
    } );

    return(
        <div
            tabIndex='0'
            className={ selectBoxClassname }
            ref={ forwardedRef }
            onClick={ props.disabled ? noop : ( event ) => {
                if( event.currentTarget !== document.activeElement ) {
                    props.onButtonClick();
                }
            } }
            onFocus={ props.disabled ? noop : ( event ) => {
                event.preventDefault();
                event.stopPropagation(); // avoid onClick event
                props.onFocus();
            } }
        >
            <div className={ titleClassName }>
                { props.placeholder }
            </div>
            {
                props.disabled ? null : (
                    <div className='ui-typeahead__select-box__icon' >
                        <Icon name='downArrow' width='12'  height='9' />
                    </div>
                )
            }
        </div>
    );
} );

// set display name
SelectBox.displayName = 'typeahead.selectBox';

/*------------------- */

export const typeahead = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-typeahead', props.className );

    return (
        <div className={ widgetClassName }>
            { props.searchable ? (
                <SearchInput
                    ref={ props.searchInputRef }
                    borderless={ props.borderless }
                    placeholder={ getLabel( props.placeholder ) }
                    size={ props.size }
                    value={ props.searchQuery }
                    loading={ props.isFetching }
                    onChange={ props.onQueryChange }
                    disabled={ props.disabled }
                    hideIcon={ props.hideIcon }
                    onFocus={ props.onFocus }
                />
            ) : (
                <SelectBox
                    ref={ props.selectButtonRef }
                    placeholder={ isEmpty( props.selectedValTitle ) ? props.placeholder : join( props.selectedValTitle, ',' ) }
                    onButtonClick= { props.onButtonClick }
                    size={ props.size }
                    value= { props.selectedValTitle }
                    disabled={ props.disabled }
                    onFocus={ props.onFocus }
                    type={ props.type }
                />
            ) }
             { /* adding blank space below search health condition and common allergies search field */}
            { (props.activeblankdiv === true) && <div className='addBlankSpace'></div>}

        </div>
    );
};

// set display name
typeahead.displayName = 'typeahead';

// set default props
typeahead.defaultProps = {
	searchInputRef: undefined,
	searchQuery: '',
	isFetching: false,
	size: undefined,
	placeholder: GLOBAL_LABELS.DISPLAY_TEXT_TYPE_TO_SEARCH,
    onQueryChange: noop,
    disabled: false,
    borderless: false,
};

// prop types
typeahead.propTypes = {};
